import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import AlertBanner from 'tio-ui/components/alert-banner';
import t from 'ember-intl/helpers/t';

<template>
  <VStack>
    <PageHeader @title={{t "strategy_finder_0726.title"}}>
      <:below>
        <AlertBanner @intent="info" data-test-sf-0726-bill-alert>
          <h2 class="text-base">
            <strong>{{t "strategy_finder_0726.bill_alert.header"}}</strong>
          </h2>
          <p>{{t "strategy_finder_0726.bill_alert.body"}}</p>
        </AlertBanner>
      </:below>
    </PageHeader>
    {{outlet}}
  </VStack>
</template>
